import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService } from '../../services/users.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-remind-password',
  standalone: false,
  templateUrl: './remind-password.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./remind-password.component.scss']
})
export class RemindPasswordComponent implements OnInit {
  resetForm: FormGroup;
  errorMessage = '';
  successMessage = '';

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private usersService: UsersService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.resetForm = this.fb.group({
      email: [''],
      token: [''],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: this.passwordsMatch });
  }

  ngOnInit(): void {
    const email = this.route.snapshot.queryParamMap.get('email') || '';
    const token = this.route.snapshot.queryParamMap.get('token') || '';
    this.resetForm.patchValue({ email, token });
  }

  passwordsMatch(form: FormGroup) {
    const pass = form.get('password')?.value;
    const confirm = form.get('confirmPassword')?.value;
    return pass === confirm ? null : { mismatch: true };
  }

  onSubmit() {
    if (this.resetForm.valid) {
      const { email, token, password } = this.resetForm.value;
      this.usersService.resetPassword({ email, token, password }).subscribe({
        next: () => {
          this.snackBar.open('Hasło zostało zmienione pomyślnie.', 'Zamknij', {
            duration: 11000,
            panelClass: ['success-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
          });
          this.resetForm.reset();
          setTimeout(() => {
            this.router.navigate(['/logowanie']);
          }, 1000); // Redirect after 1s
        },
        error: () => {
          this.snackBar.open('Nie udało się zmienić hasła. Spróbuj ponownie.', 'Zamknij', {
            duration: 4000,
            panelClass: ['error-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
          });
        }
      });
    } else if (this.resetForm.hasError('mismatch')) {
      this.snackBar.open('Hasła nie są takie same.', 'Zamknij', {
        duration: 4000,
        panelClass: ['error-snackbar'],
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
      });
    }
  }
}